'use client'
import { cn } from '~/lib/utils'
import React, { useState } from 'react'
import { Button } from '../ui/button'
import { CheckIcon, CopyIcon } from 'lucide-react'
type Props = {
    'data-language'?: string
} & React.HTMLProps<HTMLPreElement>

const Pre = (props: Props) => {
    const [isCopied, setIsCopied] = useState(false)
    const ref = React.useRef<HTMLPreElement>(null)
    const handleCopy = () => {
        const text = ref.current?.innerText
        navigator.clipboard.writeText(text ?? '')
        setIsCopied(true)
        setTimeout(() => {
            setIsCopied(false)
        }, 2000)
    }
    const language = props['data-language']
    return (
        <div className='scrollbar group my-4 rounded-lg' style={props.style}>
            <pre
                ref={ref}
                {...props}
                className={cn(
                    props.className,
                    'scrollbar px-0! overflow-x-auto rounded-xl text-sm lg:text-base'
                )}
            >
                <div className='flex items-center justify-between border-b px-2 py-1'>
                    <span className='text-sm pl-1 capitalize'>
                        {language}
                    </span>
                    <Button variant='ghost' size={'icon'} className='size-7 opacity-80 hover:opacity-100' onClick={handleCopy}>
                        {isCopied ? <CheckIcon className='size-4' /> : <CopyIcon className='size-4' />}
                    </Button>
                </div>
                {props.children}
            </pre>
        </div>
    )
}

export default Pre
